import { IconAtSign, IconNote, IconUsers } from '../../../common/icons';
import { CONTACT_MAX, NAME_MAX, STATUS_OPTIONS } from '../utils/form';

import '../styles/form.css';

// The client form body, shared by create and edit so the two cannot drift.
// Presentational only: it owns no state and knows no endpoint. The rules live
// in ../utils/form.js.
//
// Layout from design/referencias/form.png: two columns of pill inputs with the
// icon inside on the right, and the long field spanning both.

export default function ClientFields({ values, errors = {}, onChange, disabled }) {
    const set = (field) => (e) => onChange(field, e.target.value);

    return (
        <div className="client-form__grid">
            <label className="client-form__field">
                <span className="client-form__label">
                    Nombre <span className="client-form__required">*</span>
                </span>
                <span className="client-form__control">
                    <input
                        className={`client-form__input ${errors.name ? 'client-form__input--invalid' : ''}`}
                        type="text"
                        value={values.name}
                        onChange={set('name')}
                        maxLength={NAME_MAX}
                        placeholder="Nombre del cliente"
                        disabled={disabled}
                        required
                    />
                    <span className="client-form__icon" aria-hidden="true"><IconUsers /></span>
                </span>
                {errors.name && <span className="client-form__error">{errors.name}</span>}
            </label>

            <label className="client-form__field">
                <span className="client-form__label">Contacto</span>
                <span className="client-form__control">
                    <input
                        className={`client-form__input ${errors.contact ? 'client-form__input--invalid' : ''}`}
                        type="text"
                        value={values.contact}
                        onChange={set('contact')}
                        maxLength={CONTACT_MAX}
                        placeholder="Correo, teléfono o a quién escribirle"
                        disabled={disabled}
                    />
                    <span className="client-form__icon" aria-hidden="true"><IconAtSign /></span>
                </span>
                {errors.contact && <span className="client-form__error">{errors.contact}</span>}
            </label>

            <label className="client-form__field client-form__field--wide">
                <span className="client-form__label">Notas</span>
                <span className="client-form__control">
                    <textarea
                        className={`client-form__input client-form__input--area ${errors.notes ? 'client-form__input--invalid' : ''}`}
                        value={values.notes}
                        onChange={set('notes')}
                        rows={4}
                        placeholder="Lo que haga falta recordar de este cliente"
                        disabled={disabled}
                    />
                    {/* Pinned to the top on a box this tall — vertically centred
                        it would float in the middle of the text. */}
                    <span className="client-form__icon client-form__icon--top" aria-hidden="true">
                        <IconNote />
                    </span>
                </span>
                {errors.notes && <span className="client-form__error">{errors.notes}</span>}
            </label>

            <label className="client-form__field">
                <span className="client-form__label">Estado</span>
                <span className="client-form__control">
                    {/* No icon: the native select draws its own arrow on the
                        right and the two would sit on top of each other. */}
                    <select
                        className="client-form__input client-form__input--select"
                        value={values.status}
                        onChange={set('status')}
                        disabled={disabled}
                    >
                        {STATUS_OPTIONS.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                </span>
                {errors.status && <span className="client-form__error">{errors.status}</span>}
            </label>
        </div>
    );
}
